export default __webpack_public_path__ + "static/media/mysql.5dbd7ffb.svg";